export default "./dist/stdassets/images/icons/legend-layer.png";